module.exports = __webpack_public_path__ + "static/regressio-testing-3d0b1343430799ab045072a83fe307bc.png";